import React from 'react';
import { createRoot } from 'react-dom/client';
// import ReactDOM from 'react-dom';
import App from './App';
import { AuthProvider } from './common/store/authStore';

// const analytics = getAnalytics(app);

// Before
// ReactDOM.render(<App />, document.getElementById('root'));

// After
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

